// hocs/withPremium.js
import { useUser, usePremium } from "contexts";

/**
 * Higher-order component to check if the user is premium in.
 * If the user is not premium in, renders null.
 * Otherwise, renders the wrapped component.
 *
 * @param {React.ComponentType} WrappedComponent - The component to wrap.
 * @returns {React.FC} - The enhanced component with Premium control.
 */
const withPremium = (WrappedComponent) => {
  const WithPremiumComponent = (props) => {
    const { profile, loading } = useUser();
    const { isPremium } = usePremium();

    const isAuthenticated = profile?.name && !loading;
    const hasSubscription = isPremium || profile?.subscriptionId;

    if (!isAuthenticated || hasSubscription) return null;
    return <WrappedComponent {...props} />;
  };
  return WithPremiumComponent;
};

export default withPremium;
export { withPremium };
